// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");

function emptyFlags(param) {
  return /* [] */0;
}

function flagNameDecode(flagName) {
  switch (flagName) {
    case "customer_360_view" :
        return "Customer360View";
    case "general_settings_ui" :
        return "GeneralSettingsUI";
    case "insights_dashboard" :
        return "InsightsDashboard";
    case "manual_text_categorization" :
        return "ManualTextCategorization";
    case "survey_completion_redirection" :
        return "SurveyCompletionRedirection";
    case "telephonic_survey" :
        return "TelephonicSurvey";
    default:
      return "DummyFlag";
  }
}

function fromJson(json) {
  return {
          flag: flagNameDecode(Json_decode.field("flag", Json_decode.string, json)),
          description: Json_decode.field("description", Json_decode.string, json),
          enabled: Json_decode.field("enabled", Json_decode.bool, json)
        };
}

function decode(json) {
  return Json_decode.field("release_flags", (function (param) {
                return Json_decode.list(fromJson, param);
              }), json);
}

function isEnabled(releaseFlags, flagName) {
  var requiredFlag = List.find_opt((function (rf) {
          return rf.flag === flagName;
        }), releaseFlags);
  if (requiredFlag !== undefined) {
    return requiredFlag.enabled;
  } else {
    return false;
  }
}

exports.emptyFlags = emptyFlags;
exports.isEnabled = isEnabled;
exports.decode = decode;
/* No side effect */
